import { call, put } from 'redux-saga/effects';
// COMMON
import { notification } from 'elements';
import * as actionTypes from '@/redux/new_store_structure/actions/actionsTypes';
import { wsClient } from '@/index';

export function* getReplayListSaga(action) {
	/**
	 * @param clientId
	 * @param siteId
	 */
	const { params } = action.payload;
	const requestPayload = {
		messageType: 'evacuation.evacuation.list-evacuation-history',
		payload: {
			...params,
		},
	};

	try {
		const { payload } = yield wsClient.request(requestPayload);
		yield put({
			type: actionTypes.EVAC_REPLAY_LIST_SUCCESS,
			payload,
		});
	} catch (error) {
		console.log('ERR', error);
		yield put({
			type: actionTypes.EVAC_REPLAY_FAILED,
			payload: { error },
		});
		yield call(notification.error, {
			message: 'Error',
			description: error.message,
			placement: 'bottomLeft',
		});
	}
}

export function* getReplayDataSaga(action) {
	/**
	 * @param clientId
	 * @param siteId
	 * @param startTime
	 */
	const { params } = action.payload;
	const requestPayload = {
		messageType: 'evacuation.evacuation.get-evacuation-history-log',
		payload: {
			...params,
		},
	};
	yield put({ type: actionTypes.EVAC_REPLAY_START });
	try {
		const { payload } = yield wsClient.request(requestPayload);
		yield put({
			type: actionTypes.EVAC_REPLAY_DATA_SUCCESS,
			payload,
		});
	} catch (error) {
		console.log('ERR', error);
		yield put({
			type: actionTypes.EVAC_REPLAY_FAILED,
			payload: { error },
		});
		yield call(notification.error, {
			message: 'Error',
			description: error.message,
			placement: 'bottomLeft',
		});
	}
}



// WEBPACK FOOTER //
// ./src/redux/new_store_structure/sagas/evacReplay.js